import { BehaviorSubject, combineLatest, Observable, Subject } from 'rxjs'
import { map } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { bookingSelectors } from 'src/app/features/booking/booking.selectors'
import { participationSelectors } from 'src/app/features/booking/participation/participation.selectors'
import { ProductGroup } from 'src/app/features/product/product-group/product-group'

import { Component, Input, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'

import { saleItemSelectors } from '../../sale-item/sale-item.selectors'
import moment from 'moment-mini'

@Component({
  selector: 'organize-bookings',
  templateUrl: './organize-bookings.component.html',
  styleUrls: ['./organize-bookings.component.scss']
})
export class OrganizeBookingsComponent implements OnInit {
  @Input() productGroups: ProductGroup[]
  @Input() saleId: number

  public selectedProductGroupId$: Subject<number> = new BehaviorSubject<number>(
    null
  )
  public activeTabIndex: number = 0
  public fetchDates$: Observable<{
    fetchFromDate: moment.Moment
    fetchUntilDate: moment.Moment
  }>

  public saleBookingIds$: Observable<number[]>

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    if (this.productGroups.length) {
      this.selectedProductGroupId$.next(this.productGroups[0].id)
    }

    this.saleBookingIds$ = combineLatest([
      this.store.select(participationSelectors.selectAll),
      this.store.select(saleItemSelectors.selectEntities)
    ]).pipe(
      map(([participations, saleItemEntities]) => [
        ...new Set(
          participations
            .filter(
              (participation) =>
                saleItemEntities[participation?.saleItemId]?.saleId ==
                this.saleId
            )
            .map((participation) => participation.bookingId)
        )
      ])
    )

    this.fetchDates$ = combineLatest([
      this.saleBookingIds$,
      this.store.select(bookingSelectors.selectEntities)
    ]).pipe(
      map(([saleBookingIds, bookingEntities]) => {
        const saleBookings = saleBookingIds
          .map((bookingId) => bookingEntities[bookingId])
          .filter((booking) => booking)

        let fetchFromDate
        let fetchUntilDate
        for (let booking of saleBookings) {
          if (
            !fetchFromDate ||
            moment(fetchFromDate).isAfter(moment(booking?.startDate))
          ) {
            fetchFromDate = moment(booking?.startDate).startOf('day')
          }

          if (
            !fetchUntilDate ||
            moment(fetchUntilDate).isBefore(moment(booking?.startDate))
          ) {
            fetchUntilDate = moment(booking?.startDate).endOf('day')
          }
        }

        return {
          fetchFromDate,
          fetchUntilDate
        }
      })
    )
  }

  public changeSelectedProductGroup(index: number) {
    this.activeTabIndex = index
    this.selectedProductGroupId$.next(this.productGroups[index].id)
  }
}
